module.exports = __webpack_public_path__ + "images/lp-sl-m-anastasia-kuznetsova.webp";